<template>
  <div class="page">
    <div class="export-row">
      <h3>{{$t('智能硬件管理')}}</h3>
      <el-button type="primary" @click="handleBatchExport">{{$t('批量导出')}}</el-button>
    </div>

    <template v-for="item in comps">
      <el-card :key="item.comp">
        <template #header>
          <h4>{{ $t(item.label) }}</h4>
        </template>
        <component :is="item.name" :isPlain="true" @select="handleSelect" />
      </el-card>
    </template>
  </div>
</template>

<script>
import PowerSet from "@/components/hardware/PowerSet";
import AutoStart from "@/components/hardware/AutoStart";
import LightSet from "@/components/hardware/LightSet";
import Temperature from "@/components/hardware/Temperature";
import HintSound from "@/components/hardware/HintSound";
import RenewSet from "@/components/hardware/RenewSet";
import PrecisionAdjust from "@/components/hardware/PrecisionAdjust";
import PrecisionSet from "@/components/hardware/PrecisionSet";
import DeviceButton from "@/components/hardware/DeviceButton";
import RecipeOperate from "@/components/hardware/RecipeOperate";
import {request} from "@/config/request";
import {downloadFile} from "@/utils/common";

export default {
  name: "HardwareExport",
  components: {
    DeviceButton,
    PrecisionSet,
    PrecisionAdjust, RenewSet, RecipeOperate, HintSound, Temperature, LightSet, AutoStart, PowerSet
  },
  data() {
    return {
      comps: [
        {name: "PowerSet", label: "开关机设置"},
        {name: "AutoStart", label: "感应重量自动开机"},
        {name: "LightSet", label: "亮屏设置"},
        {name: "Temperature", label: "温度设置"},
        {name: "HintSound", label: "按键提示音"},
        {name: "RecipeOperate", label: "菜谱操作设定"},
        {name: "RenewSet", label: "恢复出厂设置"},
        {name: "PrecisionAdjust", label: "精度调整"},
        {name: "PrecisionSet", label: "精度设置"},
        {name: "DeviceButton", label: "按键功能"},
      ],
      exportForm: {}
    }
  },
  methods: {
    // 批量导出
    async handleBatchExport() {
      try {
        /*const codes = Object.values(this.exportForm);
        if(!codes.flat().length) {
          this.$message.warning("请选择导出数据");
          return;
        }*/
        const res = await request(this.$api.common.hardwareExport, this.exportForm, {isJson: true});
        downloadFile(res.excelUrl);
      } catch (e) {
        console.log(e);
      }
    },

    handleSelect(obj) {
      for (const key in obj) {
        this.exportForm[key] = obj[key];
      }
    }
  }
}
</script>

<style scoped>

.page {
  position: relative;
}

.el-card {
  margin-bottom: 18px;
}

.export-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  background: #FFFFFF;
  position: sticky;
  top: 0;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 12px;
  z-index: 2;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

</style>
